import { forwardRef } from 'react'

import type { Props as BoxProps } from '../box/box'
import { Box } from '../box/box'

type Props = Omit<BoxProps, 'display'>

/**
 * @deprecated Use Tailwind CSS flex utilities on native HTML elements instead.
 * Example: `<div className="flex items-center gap-small">`
 */
export const Flex = forwardRef<HTMLElement, Props>((props, ref) => <Box ref={ref} display="flex" {...props} />)

Flex.displayName = 'Flex'
